import { QueryClient } from '@tanstack/react-query'

/** Cliente TanStack Query para NeoCore (ADR 014). Defaults conservadores:
 *  reintento único y datos frescos por 30s para paneles operativos. */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: 1, staleTime: 30_000, refetchOnWindowFocus: false },
  },
})
